import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useAuth } from "../../accounts/AuthProvider";
import { acceptInvitation } from "../../accounts/accessRequests";
import Card from "../UI/Card";
import classes from "./AccountPage.module.css";

const InvitationPage = ({ type = "invite" }) => {
  const description = type === "recovery" ? "password reset link" : "invitation";
  const heading = type === "recovery" ? "Reset your password" : "Accept invitation";
  const { client, configured, loading, error } = useAuth();
  const { search } = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(search).get("token_hash");
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!client || loading || error || !token) return;
    let active = true;
    acceptInvitation(client, token, type).then(result => {
      if (!active) return;
      if (result.error || !result.data?.session) throw new Error("Invalid invitation");
      navigate("/account/reset-password", { replace: true });
    }).catch(() => {
      if (!active) return;
      setFailed(true);
      navigate(type === "recovery" ? "/account/reset-password?link_error=expired" : "/account/invite", { replace: true });
    });
    return () => { active = false; };
  }, [client, loading, error, token, navigate, type]);
  return <Card className={classes.panel}>
    <HelmetProvider><Helmet><title>{heading} | Guitar Charts</title><meta name="robots" content="noindex, nofollow" /></Helmet></HelmetProvider>
    <h1>{heading}</h1>
    {!configured ? <p>Accounts are not available on this version of the site yet.</p>
      : failed || !token || error ? <p role="alert">This {description} is invalid or expired. Please request a new one.</p>
      : <p role="status">Checking your {description}…</p>}
    <p><Link to="/account">Return to sign in</Link></p>
  </Card>;
};

export default InvitationPage;
